<template>
	<BarChart v-bind="{ data, options, styles, params, refresh, height }" />
</template>

<script>
import moment from "moment";
import BarChart from "./bar.vue";

export default {
	name: "CasesBarChart",
	components: {
		BarChart, // Use BarChart component
	},
	props: {
		hideTitle: {
			type: Boolean,
			default: false,
		},
		height: {
			type: String,
			default: "300px",
		},
		startDate: {
			type: Object,
			default: () => {
				return moment().add(-30, "days");
			},
		},
		endDate: {
			type: Object,
			default: () => {
				return moment();
			},
		},
		params: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			loading: false,
			labelFormat: "MM-DD-yyyy",
			dateFormat: "YYYY-MM-DD",
			casesData: {
				open: [],
				utc: [],
				closed: [],
				totalOpen: 0,
				totalUtc: 0,
				totalClosed: 0,
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				elements: {
					point: {
						radius: 3,
					},
				},
				scales: {
					y: {
						beginAtZero: true,
						ticks: {
							stepSize: 1, // Specifies the interval between ticks
							precision: 0 // Specifies the number of decimal places to display
						}
					},
				},
				plugins: {
					title: {
						display: !this.hideTitle,
						text: "Cases",
					},
				},
			},
		};
	},
	computed: {
		labels() {
			var days = [];
			var day = this.startDate;

			while (day <= this.endDate) {
				days.push(day.format(this.labelFormat));
				day = day.clone().add(7, "d");
			}

			return days;
		},
		styles() {
			return {
				position: "relative",
				height: this.height,
			};
		},
		data() {
			return {
				labels: this.labels,
				datasets: [
					{
						label: 'New',
						borderColor: "rgb(37, 99, 235)",
						backgroundColor: 'rgb(37, 99, 235)',
						// data: this.casesData.open, // Use the counts as data
						data: this.casesData.open
							? Object.keys(this.casesData.open).map((e) => this.casesData.open[e])
							: [],
					},
					{
						label: 'UTC',
						borderColor: "rgb(255, 193, 7)",
						backgroundColor: 'rgb(255, 193, 7)',
						// data: this.casesData.utc,
						data: this.casesData.utc
							? Object.keys(this.casesData.utc).map((e) => this.casesData.utc[e])
							: [],
					},
					{
						label: 'Closed',
						borderColor: "rgb(0, 0, 0)",
						backgroundColor: 'rgb(106, 135, 155)',
						// data: this.casesData.closed,
						data: this.casesData.closed
							? Object.keys(this.casesData.closed).map((e) => this.casesData.closed[e])
							: [],
					}
				],
			};
		},
	},
	mounted() {
		window.onresize = () => {
			this.windowWidth = window.innerWidth;
		};

		this.refresh();
	},
	methods: {
		async refresh() {
			try {
				this.loading = true;

				const response = await this.$store.dispatch("charts/cases", {
					start: this.startDate.format(this.dateFormat),
					end: this.endDate.add(7, "days").format(this.dateFormat),
					params: this.params,
				});

				

				// this.casesData = response;
				// casesData: {
				// 	open: [],
				// 	utc: [],
				// 	closed: [],
				// },
				this.casesData = {
					open: response.open ?? [],
					utc: response.utc ?? [],
					closed: response.closed ?? [],
					totalOpen: response.totalOpen ?? 0,
					totalUtc: response.totalUtc ?? 0,
					totalClosed: response.totalClosed ?? 0,
				};
				this.$emit("casesDataLoaded", this.casesData);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
